if (!customElements.get('compare-images')) {
  class CompareImages extends HTMLElement {
    connectedCallback() {
      this.overlap = this.querySelector('[data-image-holder]');
      this.button = this.querySelector('[data-range-button]');
      this.input = this.querySelector('[data-range-input]');
      this.container = this.querySelector('[data-images-container]') || this;

      this.percent = this.input ? Number(this.input.value) : 50;
      this.refresh();

      this.onInput = this.onInput.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
      this.onDragMove = this.onDragMove.bind(this);
      this.onDragEnd = this.onDragEnd.bind(this);

      if (this.input) this.input.addEventListener('input', this.onInput);
      if (this.button) {
        this.button.addEventListener('mousedown', this.onDragStart);
        this.button.addEventListener('touchstart', this.onDragStart, { passive: false });
      }
    }

    disconnectedCallback() {
      this.onDragEnd();
    }

    onInput(event) {
      this.setPercent(Number(event.target.value));
    }

    onDragStart(event) {
      event.preventDefault();
      document.addEventListener('mousemove', this.onDragMove);
      document.addEventListener('mouseup', this.onDragEnd);
      document.addEventListener('touchmove', this.onDragMove, { passive: false });
      document.addEventListener('touchend', this.onDragEnd);
    }

    onDragMove(event) {
      const point = event.touches ? event.touches[0] : event;
      const rect = this.container.getBoundingClientRect();
      if (!rect.width) return;
      const percent = ((point.clientX - rect.left) / rect.width) * 100;
      this.setPercent(percent);
    }

    onDragEnd() {
      document.removeEventListener('mousemove', this.onDragMove);
      document.removeEventListener('mouseup', this.onDragEnd);
      document.removeEventListener('touchmove', this.onDragMove);
      document.removeEventListener('touchend', this.onDragEnd);
    }

    setPercent(percent) {
      this.percent = Math.max(0, Math.min(100, percent));
      this.refresh();
    }

    refresh() {
      if (this.overlap) this.overlap.style.setProperty('--handle-position', `${this.percent}%`);
      if (this.button) this.button.style.left = `${this.percent}%`;
      if (this.input) this.input.value = this.percent;
    }
  }

  customElements.define('compare-images', CompareImages);
}

if (!customElements.get('before-after-tabs')) {
  class BeforeAfterTabs extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.activate(trigger.dataset.tabTrigger));
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.activate(trigger.dataset.tabTrigger);
          }
        });
      });
    }

    activate(id) {
      this.triggers.forEach((trigger) => {
        const isActive = trigger.dataset.tabTrigger === id;
        trigger.classList.toggle('activeTab', isActive);
        trigger.setAttribute('aria-selected', isActive);
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle('activeTabContent', panel.dataset.tabPanel === id);
      });
    }
  }

  customElements.define('before-after-tabs', BeforeAfterTabs);
}

if (!customElements.get('quick-add-product')) {
  class QuickAddProduct extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.button = this.querySelector('[data-add-to-cart]');
      this.errorMessage = this.querySelector('[data-message-error]');
      this.miniCart = document.querySelector('mini-cart');
      this.resetTimeout = null;

      this.onSubmit = this.onSubmit.bind(this);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);
    }

    onSubmit(event) {
      event.preventDefault();
      if (!this.button || this.button.classList.contains('loading')) return;

      clearTimeout(this.resetTimeout);
      this.button.classList.remove('is-success', 'is-error');
      this.button.classList.add('loading');
      this.button.setAttribute('disabled', 'disabled');
      if (this.errorMessage) this.errorMessage.textContent = '';

      const variantField = this.form.querySelector('[name="id"]');
      const variantId = variantField ? variantField.value : null;
      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
      const config = window.fetchConfig
        ? window.fetchConfig('javascript')
        : {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/javascript'
            }
          };

      fetch(window.routes.cart_add_url, {
        ...config,
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections,
          sections_url: window.location.pathname
        })
      })
        .then((response) => response.json())
        .then((parsedState) => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('disabled');

          if (parsedState.status) {
            this.button.classList.add('is-error');
            if (this.errorMessage) this.errorMessage.textContent = parsedState.description;
            document.dispatchEvent(
              new CustomEvent('ajaxProduct:error', {
                detail: { errorMessage: parsedState.description }
              })
            );
          } else {
            this.button.classList.add('is-success');
            this.miniCart && this.miniCart.renderContents(parsedState);
            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                detail: { product: parsedState }
              })
            );
          }

          this.resetTimeout = setTimeout(() => {
            this.button.classList.remove('is-success', 'is-error');
          }, 2000);
        })
        .catch((error) => {
          console.error(error);
          this.button.classList.remove('loading');
          this.button.classList.add('is-error');
          this.button.removeAttribute('disabled');
        });
    }
  }

  customElements.define('quick-add-product', QuickAddProduct);
}
